import { Box, Checkbox, Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const PublicSelectField: React.FC<{
  tooltipLabel?: string
  fieldDescription?: string
  value: boolean
  onChange: (value: boolean) => void
}> = ({ value, onChange, tooltipLabel, fieldDescription }) => {
  const [open, toggle] = useToggle(false)

  return (
    <>
      <Box flexDirection="row" gap="s8">
        <Checkbox
          label={i18n.t('performance_goals.create_metric_group_modal.public')}
          checked={value}
          onChange={() => onChange(!value)}
        />
        <Tooltip.Alt
          attachment="top center"
          label={
            tooltipLabel ?? i18n.t('performance_goals.create_metric_group_modal.public_info_label')
          }
          open={open}
          toggle={toggle}
        >
          <Icon.Medium icon="info-circle-line" color="grey800" />
        </Tooltip.Alt>
      </Box>
      <span>
        {fieldDescription ??
          i18n.t('performance_goals.create_metric_group_modal.public_description')}
      </span>
    </>
  )
}
